import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import FnrErrorText from "UI/FnrErrorText/FnrErrorText";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const Container = styled(FnrHorizontalGap)`
  display: flex;
  justify-content: ${({ $flexEnd }) =>
    $flexEnd ? "flex-end" : "space-between"};
  ${({ $hideMargin }) => ($hideMargin ? "" : "margin-bottom: 2px;")}
`;

const SFnrVerticalGap = styled(FnrVerticalGap)`
  flex-grow: 1;
  text-align: right;
`;

const stylesByVariant = {
  confirmColor: { danger: "red", cta: "green", cta2: "#2867ac" },
  cancelColor: { cta: "blue", cta2: "#4e99d1" },
};

const ariaLabelByVariant = {
  cta: "action-button",
  cta2: "action-button",
  danger: "danger-button",
  default: "save-button",
};

const FnrConfirmCancel = ({
  cancelText = "Cancel",
  confirmText = "Save",
  confirmColor,
  icon,
  cancel,
  confirm,
  error,
  errorText = "Something went wrong there. Please try again or contact support.",
  variant = "default",
  isLoading,
  cancelIsLoading,
  disableConfirm,
  hideMargin,
  autoFocus,
  hideConfirmButton,
  children,
  ...rest
}) => {
  return (
    <SFnrVerticalGap {...rest}>
      <Container $hideMargin={hideMargin} $flexEnd={hideConfirmButton}>
        <FnrButton
          onClick={cancel}
          color={stylesByVariant.cancelColor[variant] || "gray"}
          loading={cancelIsLoading}
          aria-label="cancel-button"
        >
          <span>{cancelText}</span>
        </FnrButton>
        {children}
        {!hideConfirmButton && (
          <FnrButton
            data-cy="FnrConfirmCancel_ConfirmButton"
            onClick={confirm}
            color={
              confirmColor || stylesByVariant.confirmColor[variant] || "blue"
            }
            loading={isLoading}
            disabled={disableConfirm || isLoading}
            autoFocus={autoFocus}
            aria-label={ariaLabelByVariant[variant]}
          >
            <FnrHorizontalGap>
              {icon && <FnrIcon icon={icon} />}
              {confirmText && <span>{confirmText}</span>}
            </FnrHorizontalGap>
          </FnrButton>
        )}
      </Container>
      <FnrErrorText error={error}>{errorText}</FnrErrorText>
    </SFnrVerticalGap>
  );
};

FnrConfirmCancel.propTypes = {
  cancelText: PropTypes.node,
  confirmText: PropTypes.node,
  icon: PropTypes.string,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  variant: PropTypes.oneOf(["danger", "default", "cta", "cta2"]),
  /** Hides the 2px margin-bottom that is added to always show button shadows.
   * Use this when implementing anywhere other than the bottom of a div. */
  hideMargin: PropTypes.bool,
  autoFocus: PropTypes.bool,
  isLoading: PropTypes.bool,
  cancelIsLoading: PropTypes.bool,
  disableConfirm: PropTypes.bool,
  hideConfirmButton: PropTypes.bool,
  children: PropTypes.node,
};

export default FnrConfirmCancel;
